module.exports = __webpack_public_path__ + "img/English-10.b43440ad.jpg";